import React from 'react';
import { Button, Header, Icon, Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const NotificationDialog = ({
  title,
  message,
  showDialog,
  onOkClick,
  showCancel,
  onCancelClick,
  okButtonText,
  cancelButtonText,
}) => {
  return (
    <Modal size="small" open={showDialog}>
      <Header icon="info circle" content={title} />
      <Modal.Content>
        {typeof message === 'string' ? <strong>{message}</strong> : message}
      </Modal.Content>
      <Modal.Actions>
        {showCancel && (
          <Button basic onClick={onCancelClick}>
            <strong>{cancelButtonText}</strong>
          </Button>
        )}
        <Button primary onClick={onOkClick}>
          <Icon className={'icon--white'} name="checkmark" /> {okButtonText}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

NotificationDialog.propTypes = {
  showDialog: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.any,
  onOkClick: PropTypes.func,
  showCancel: PropTypes.bool,
  onCancelClick: PropTypes.func,
  okButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
};

NotificationDialog.defaultProps = {
  onOkClick: () => {},
  onCancelClick: () => {},
  okButtonText: 'Ok',
  cancelButtonText: 'Cancel',
};

export { NotificationDialog };



// WEBPACK FOOTER //
// ./src/components/dialogs/NotificationDialog.js